import { UploadSourcesList } from "../sources/@types/UploadSource";

const SUPPORTED_EDR_CONNECTORS = [
  "falcon_connector",
  "cortex_connector",
  "sentinelone_connector",
  "msdefender_connector"
];

const getIsEmail = (fileType?: string) => {
  if (!fileType) return false;
  return fileType.toLowerCase().startsWith("email");
};

const getHasThreatName = (threatName?: string) =>
  Boolean(threatName) && threatName?.toLowerCase() !== "unknown";

const filterConnectorUploads = (data?: UploadSourcesList) =>
  data?.filter(upload =>
    SUPPORTED_EDR_CONNECTORS.includes(upload?.user || "")
  ) || [];

const getMediaAddressParagraphSuffix = (maliciousCount: number) => {
  if (maliciousCount === 0) {
    return "and none are classified as malicious";
  } else if (maliciousCount === 1) {
    return "and 1 is classified as malicious";
  } else {
    return `and ${maliciousCount} are classified as malicious`;
  }
};

export {
  filterConnectorUploads,
  getHasThreatName,
  getIsEmail,
  getMediaAddressParagraphSuffix
};
